import { render, staticRenderFns } from "./BaseMoneySpinner.vue?vue&type=template&id=2810dcaf&scoped=true&"
import script from "./BaseMoneySpinner.vue?vue&type=script&lang=js&"
export * from "./BaseMoneySpinner.vue?vue&type=script&lang=js&"
import style0 from "./BaseMoneySpinner.vue?vue&type=style&index=0&id=2810dcaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810dcaf",
  null
  
)

export default component.exports